import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import { Eye, EyeOff } from "lucide-react"; // Icônes pour afficher/masquer

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";

function EditConfigMessagerie() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [configData, setConfigData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [showPassword, setShowPassword] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  // Variable
  const [formData, setFormData] = useState({
    Utilisateur: "",
    Email: "",
    Adresse: "",
    Domaine: "",
    "Mot de passe": "",
    Port: "",
    "Client ID": "",
    "Tenant ID": "",
    "Client Secret": "",
  });

  // Fonction pour gérer les changements de valeurs
  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const [username, setUsername] = useState("");
  const [emailAssocieAuCompte, setEmailAssocieAuCompte] = useState("");
  const [address, setAddress] = useState("");
  const [domain, setDomain] = useState("");
  const [password, setPassword] = useState("");
  const [port, setPort] = useState("");
  const [clientId, setClientId] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [clientSecret, setClientSecret] = useState("");

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/smtp_parametres/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const configData = await response.json();
      setConfigData(configData);
      // Mise à jour des données en une seule fois
      setFormData((prevState) => ({
        ...prevState,
        Utilisateur:
          configData?.detail_smtp_parametre?.["Identification"]?.Utilisateur ||
          "",
        Email:
          configData?.detail_smtp_parametre?.["Identification"]?.["Email"] ||
          "",
        Adresse:
          configData?.detail_smtp_parametre?.["Identification"]?.Adresse || "",
        Domaine:
          configData?.detail_smtp_parametre?.["Identification"]?.Domaine || "",
        "Mot de passe":
          configData?.detail_smtp_parametre?.["Identification"]?.[
            "Mot de passe"
          ] || "",
        Port:
          configData?.detail_smtp_parametre?.["Identification"]?.Port || 587,
        "Client ID":
          configData?.detail_smtp_parametre?.["Identification"]?.[
            "Client ID"
          ] || "",
        "Tenant ID":
          configData?.detail_smtp_parametre?.["Identification"]?.[
            "Tenant ID"
          ] || "",
        "Client Secret":
          configData?.detail_smtp_parametre?.["Identification"]?.[
            "Client Secret"
          ] || "",
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const response = await fetch(
        `https://www.fluxod.com/${api}/smtp_parametres/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: id,
            username: formData.Utilisateur,
            email_associe_au_compte: formData.Email,
            address: formData.Adresse,
            domain: formData.Domaine,
            password: formData["Mot de passe"],
            port: formData.Port,
            client_id: formData["Client ID"],
            tenant_id: formData["Tenant ID"],
            client_secret: formData["Client Secret"],
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.impression_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.impression_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Compte de messagerie | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Compte de messagerie
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/smtp_parametres/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Compte de messagerie
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          configData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Col>
                                  {configData?.detail_smtp_parametre?.[
                                    "Identification"
                                  ] ? (
                                    <Row>
                                      <Card className="mb-4">
                                        <CardTitle tag="h5">
                                          Identification
                                        </CardTitle>
                                        <CardBody>
                                          {/* {Object.entries(
                                            configData?.detail_smtp_parametre?.[
                                              "Identification"
                                            ]
                                          ).map(([key], index) => (
                                            <Row key={index} className="mb-3">
                                              {key == "Utilisateur" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-8">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={username}
                                                      onChange={(e) =>
                                                        setUsername(e.target.value)
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              
                                              ) : (
                                                <></>
                                              )}
                                            </Row>
                                          ))} */}
                                          {Object.keys(formData).map((key) => (
                                            <Row key={key} className="mb-2">
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i>
                                                  <span>
                                                    {key}
                                                    {key != "Client ID" &&
                                                    key != "Tenant ID" &&
                                                    key != "Client Secret"
                                                      ? "*"
                                                      : ""}{" "}
                                                    :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-6 d-flex align-items-center">
                                                <input
                                                  type={
                                                    key === "Mot de passe"
                                                      ? showPassword
                                                        ? "text"
                                                        : "password"
                                                      : key === "Client Secret"
                                                      ? showClientSecret
                                                        ? "text"
                                                        : "password"
                                                      : "text"
                                                  }
                                                  className="form-control form-control-sm"
                                                  value={formData[key]}
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      key,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                {(key === "Mot de passe" ||
                                                  key === "Client Secret") && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary ms-2"
                                                    style={{
                                                      // borderRadius: "50%",
                                                      width: "30px",
                                                      height: "27px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                    onClick={() =>
                                                      key === "Mot de passe"
                                                        ? setShowPassword(
                                                            !showPassword
                                                          )
                                                        : setShowClientSecret(
                                                            !showClientSecret
                                                          )
                                                    }
                                                  >
                                                    {key === "Mot de passe" &&
                                                      (showPassword ? (
                                                        <EyeOff />
                                                      ) : (
                                                        <Eye />
                                                      ))}
                                                    {key === "Client Secret" &&
                                                      (showClientSecret ? (
                                                        <EyeOff />
                                                      ) : (
                                                        <Eye />
                                                      ))}
                                                  </button>
                                                )}
                                              </Col>
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Row>
                                  ) : null}
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditConfigMessagerie;
